export enum DateFormats {
  DATE = 'date',
  DATE_TIME = 'date-time',
  DATE_TIME_SECONDS = 'date-time-seconds',
  DATE_TIME_BRACES = 'date-time-braces',
  DATE_TIME_OPEN_BRACE = 'date-time-open-brace',
  DATE_TIME_CLOSING_BRACE = 'date-time-closing-brace',
  DATE_TIME_HIDDEN = 'date-time-hidden',
  DATE_WITH_SHORT_NAME_OF_THE_WEEK = 'date-with-short-name-of-the-week',
  MONTH_AND_YEAR = 'month-and-year',
  YEAR = 'year',
}
